<template>
    <div class="tab-group">
        <div class="filter-group row">
            <div class="col-md-6">
                <div class="display-flex justify-content-between">
                    <div class="wrap-left display-flex">
                        <div class="item item__key input-custom-icon">
                            <input v-model="keyword" v-debounce="300" type="text" placeholder="Tìm kiếm"
                                class="primary-color-txt color_bg_gray_light border-rd-20 font-size-15 form-h30 border-0 full-width">
                            <i class="icon-search font-size-16 primary-color"></i>
                        </div>

                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <label class="group-name"><strong>{{ groupNameSelected }}</strong></label>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div v-if="listGroup.length > 0">
                    <b-table ref="tableGroup" striped hover :fields="fieldsTableGroup" :items="listGroup">
                        <!-- <template #head(stt)="data">
                            <span class="col-table">{{ data.label }}</span>
                        </template> -->

                        <template #head(name)="data">
                            <span class="col-table">
                                {{ data.label }}
                            </span>
                        </template>

                        <template #cell(name)="data">
                            <!-- <span @click="handleShowLessonClassSchool(data.item)" class="col-table text-primary cursor-pointer">
                                {{ data.item.name }}
                            </span> -->
                            <div class="col-name b-col-group" @click="toggleCollapseGroup(data.item)">
                                <img class="icon-groups" width="20" src="@/assets/img/icon_groups.png" />
                                <span>{{ data.item.name }}</span>
                            </div>
                            <b-collapse class="wrap-menu-collapse" :visible="data.item.isCollapse">
                                <div class="menu-collapse" @click="handleViewListMember(data.item)"
                                    :class="currentMenuTab === data.item.id + 'tabMember' ? 'active' : ''">Danh
                                    sách học sinh </div>
                                <div class="menu-collapse" @click="handleViewListDocument(data.item)"
                                    :class="currentMenuTab === data.item.id + 'tabDocument' ? 'active' : ''">Danh
                                    sách tài liệu</div>
                            </b-collapse>
                        </template>

                    </b-table>
                </div>
                <div v-else>Không có dữ liệu danh sách nhóm</div>
            </div>
            <div v-if="listMember.length > 0 && tabRightActive == 1" class="list-member">
                    <label for="">Danh sách học sinh trong nhóm</label>
                    <b-table striped hover :fields="fieldsTableMember" :items="listMember">
                        <template #head(stt)="data">
                            <span class="col-table">{{ data.label }}</span>
                        </template>

                        <template #head(name)="data">
                            <span class="col-table">{{ data.label }}</span>
                        </template>

                        <template #cell(name)="data">
                            <router-link :to="{ path: 'thong-ke-hoc-sinh', query: { userId: data.item.userId } }"
                                target="_blank" class="text-default">
                                <strong style="color:green">{{ data.item.name }}</strong>
                            </router-link>
                            
                        </template>
                    </b-table>

                </div>
            <div class="col-md-6" v-if="isShowListLessonClassSchool && tabRightActive == 2">
                <div class="wrap-left display-flex">
                    <div class="item item__key input-custom-icon mr-3">
                        <input v-model="paramQueryDataFile.keyword" v-debounce="300" type="text" placeholder="Tìm kiếm"
                            class="primary-color-txt color_bg_gray_light border-rd-20 font-size-15 form-h30 border-0 full-width" />
                        <i class="icon-search font-size-16 primary-color"></i>
                    </div>
                    <b-form-select v-model="paramQueryDataFile.type" :options="listType"
                        class="select-sm"></b-form-select>
                </div>
                <b-list-group v-if="listDataLessonClassSchool.length > 0 ">
                    <b-list-group-item v-for="(item, index) of listDataLessonClassSchool" :key="index">
                        <div class="display-flex-center cg-1">
                            <img class="icon-link mr-2" width="20" src="@/assets/img/book-icon.png" />
                            <div class="display-flex-column">
                                <h5>{{ item.name }}</h5>
                            </div>
                        </div>
                    </b-list-group-item>
                </b-list-group>
                
                <div v-else class="text-center empty-data mt-3">Chưa có dữ liệu tài liệu</div>
                <div
                    class="row pagination pagination-flex container m-0">
                    <b-pagination pills v-model="paramQueryDataFile.pageIndex" :total-rows="totalFileRecords"
                        :per-page="paramQueryDataFile.pageSize" first-number last-number></b-pagination>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { getListMemberByGroupId } from './../../_api/classSchoolGroupUserServices'

import { getListGroupByCurrentUserId } from './../../_api/classSchoolGroupServices'
import { listLessonClassSchoolGroupService, getListFileByGroup } from './../../_api/lessonClassSchoolGroupServices'
export default {
    watch: {
        'keyword': 'getListGroup',
        'paramQueryDataFile.pageIndex': 'getListLessonClassSchoolGroup',
        'paramQueryDataFile.keyword': 'getListLessonClassSchoolGroup',
        'paramQueryDataFile.type': 'getListLessonClassSchoolGroup',
    },
    data() {
        return {
            fieldsTableMember: [{ key: 'stt', label: 'STT' }, { key: 'name', label: 'Họ tên học sinh' }],
            listMember: [],
            isShowListLessonClassSchool: false,
            listGroup: [],
            keyword: '',
            fieldsTableGroup: [{ key: 'name', label: 'Tên nhóm' }],
            classSchoolId: 0,
            listDataLessonClassSchool: [],
            totalRecords: 0,
            totalFileRecords: 0,
            paramQueryDataLesson: {
                keyword: '',
                pageIndex: 1,
                pageSize: 5,
                groupId: 0,
            },
            paramQueryDataFile: {
                keyword: '',
                pageIndex: 1,
                pageSize: 5,
                groupId: 0,
                classSchoolId: 0,
                type: 0
            },
            listFileLessonClassSchool: [],
            groupNameSelected: '',
            listType: [
                { value: 0, text: "Loại tài liệu - tất cả" },
                { value: 2, text: "Bài giảng điện tử" },
                { value: 3, text: "Bài tập/ bài kiểm tra" },
                { value: 4, text: "Kế hoạch bài dạy" },
            ],
            currentMenuTab: '',
            tabRightActive: 0
        }
    },
    mounted() {
        this.classSchoolId = this.$route.query.id
        this.getListGroup()
    },
    methods: {
        
        handleShowLessonClassSchool(row) {
            this.paramQueryDataLesson.groupId = row.id
            this.paramQueryDataFile.groupId = row.id
            this.getListLessonClassSchoolGroup()
            this.getListFileLessonClassSchoolByGroup()
            this.isShowListLessonClassSchool = true
            this.groupNameSelected = row.name
        },
        getListMemberByGroupId(id){
            this.listMember=[]
            let groupId = id
            getListMemberByGroupId(groupId).then((res)=>{
                if (res && res.data && !res.errors) {
                    for (let i = 0; i < res.data.length; i++) {
                        const item = res.data[i];
                        this.listMember.push({'id':item.id, 'stt':i+1,'name': item.userName,userId:item.userId },)
                    }
                }
            })
        },
        getListLessonClassSchoolGroup() {
            let self = this
            listLessonClassSchoolGroupService(this.paramQueryDataFile).then((res) => {
                if (res && res.data && !res.errors) {
                    self.listDataLessonClassSchool = res.data.list
                    self.totalRecords = res.data.paging.totalRecords
                }
            })
        },
        getListFileLessonClassSchoolByGroup() {
            let self = this
            this.paramQueryDataFile.classSchoolId = this.classSchoolId
            getListFileByGroup(this.paramQueryDataFile).then((res) => {
                if (res && res.data && !res.errors) {
                    self.listFileLessonClassSchool = res.data.list
                    self.totalFileRecords = res.data.paging.totalRecords
                }
            })
        },
        toggleCollapseGroup(item) {
            item.isCollapse = !item.isCollapse
            this.$refs.tableGroup.refresh();
        },
        handleViewListMember(row) {
            this.currentMenuTab = row.id + 'tabMember'
            this.tabRightActive = 1
            this.getListMemberByGroupId(row.id)
        },
        handleViewListDocument(row) {
            this.currentMenuTab = row.id + 'tabDocument'
            this.handleShowLessonClassSchool(row)
            this.tabRightActive = 2
        },
        getListGroup() {
            this.listGroup = []
            let query = {
                classSchoolId: this.classSchoolId,
                keyword: this.keyword
            }
            getListGroupByCurrentUserId(query).then((res) => {
                if (res && res.data && !res.errors) {
                    for (let i = 0; i < res.data.length; i++) {
                        const item = res.data[i];
                        this.listGroup.push({ 'id': item.id, 'stt': i + 1, 'name': item.name },)
                    }
                }
            })
        }
    }

}
</script>

<style lang="scss" scoped>
.list-member {
    max-height: 26rem;
    overflow-y: auto;
}
.wrap-menu-collapse {
    // border: 1px solid gray;
    // margin: 5px;
    // border-radius: 10px;
    border: none;
    width: max-content;
    margin-top: 10px;

    .menu-collapse {
        padding: 4px 20px;
        cursor: pointer;
    }

    .menu-collapse.active {
        background-color: #bbe0fb;
        border-radius: 20px;
        color: #2032b5;

    }

    .menu-collapse:hover {
        background: #e5e2e2;
        border-radius: 20px;
    }
}

.tab-group {
    margin-top: 20px;
}

.b-col-group {
    display: flex;
    align-items: center;
    column-gap: 0.6rem;
    border-bottom: 1px solid #ced4da;
    padding-bottom: 1rem;
    cursor: pointer;
}

.list-group {
    .list-group-item {
        border-top: 0;
        border-left: 0;
        border-right: 0;
    }
}

.pagination {
    position: absolute;
    width: 100%;
    bottom: 10px;
}
</style>
